
<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import { error, success } from "../../public/my-theme";
    import { SERVICE_URL } from "../evironment";
    import { getAccessToken } from "../services/session";

export let photoId: string;

const dispatch = createEventDispatcher();

function upDateSrc(photoId: string): string{

    let url = new URL(`/api/files/content/${photoId}` , SERVICE_URL);

    if (SERVICE_URL.includes('localhost') ) {
        url = new URL(`/files/content/${photoId}` , SERVICE_URL);
    }

    url.searchParams.set('access_token', getAccessToken());
    
    return url.toString();
}

async function removeFile(){
    if (!confirm('¿Esta seguro de querer eliminar el archivo?')) {
        return
    }

    try {
        let url = new URL('/api/files/' + photoId, SERVICE_URL);

        if (SERVICE_URL.includes('localhost') ) {
            url = new URL('/files/' + photoId, SERVICE_URL);
        }

        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'X-Access-Token': getAccessToken()
            }
        })

        if (!response.ok) {
            error('Error al actualizar el archivo')
            throw new Error('Error al eliminar el fichero');
        }

        dispatch('removeFile', photoId);
        success('Archivo eliminado correctamente')

    } catch (error) {
        console.log(error);
    }
}

</script>


<img class="w-100" src={upDateSrc(photoId)}  alt="">

<button class="mt-3 btn btn-danger" type="button" on:click={removeFile}> Eliminar </button>


